/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React from 'react';

/* APP E SERVIÇOS */

import { useAppContextoReact } from "../../servicos/app/AppContextoReact.tsx";
import AppConfig from '../../AppConfig.ts';
import appTema from '../../servicos/mui/Theme.ts';
import StyledStack from '../../servicos/mui/StyledStack.tsx';
import { StyledAccordion, StyledAccordionSummary, StyledAccordionDetails } from '../../servicos/mui/StyledAccordion';
import OptionsController, {IOptions} from '../../servicos/forms/OptionsController.ts';


/* FORM E FIELDS */

import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Autocomplete, Box, Button, FormControl, Grid,InputLabel, MenuItem, Paper, Switch, Tab, Tabs, Typography, useMediaQuery, } from '@mui/material';
import TextField from '@mui/material/TextField';

import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';

import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import VisuallyHiddenInput from "../../servicos/mui/VisuallyHiddenInput.tsx";
import ChecklistIcon from '@mui/icons-material/Checklist';
import AttachFileIcon from '@mui/icons-material/AttachFile';
//import VisuallyHiddenInput from "../../servicos/mui/VisuallyHiddenInput";

/* INTERFACES E ENUMERAÇÕES */

import { IEntidadesData, IProdutoras, IRetornoAjaxEntidades } from '../../servicos/entidades/Entidades_FrontAPI.ts';
import { User } from 'firebase/auth';
import { DataType, ETYPEFORM, IFormStateEntidades, IPropsAnexo, TipoAnexo, bananinhaListError, validacao } from '../../servicos/IFormularios.ts';
import EntidadesController from '../../servicos/entidades/EntidadesController.ts';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha.tsx';
import AddEditComponent from '../../componentes/formularios/_AddEditComponent.tsx';
import {EFORM} from '../../componentes/formularios/EFORM.tsx';
import { ProgramaModel } from "../../servicos/IFormularios";

import { isDate, isUndefined, isNull, isEmpty } from 'lodash';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

/* DATA */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { ptBR } from '@mui/x-date-pickers/locales';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

/* UTIL */
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { createSimulatedFileList, a11yProps, isValidDate, transformarData, prepararSerieFormData, prepararFormDataAnexo } from '../../util/formDialogUtil.tsx';

dayjs.extend(utc);
dayjs.extend(timezone);

interface IPropsFormLightbox
{
	operacao: EFORM
	entidade: IFormStateEntidades
	setEntidade: (entidade: IFormStateEntidades) => void
	openDialog: boolean
	listViews: boolean
	setOpenDialog: (openDialog: boolean) => void
	callBack: () => void
}

const FormDialog = (props:IPropsFormLightbox) =>
{
	const appContext = useAppContextoReact();
	const EntController = new EntidadesController();
	const OptsController = new OptionsController();

	const [user, setUser] = React.useState<User|null|undefined>(null);
	const [bananinhaDelegate, setBananinhaDelegate] = React.useState<IBananinhaDelegate|undefined>(undefined);
	const [onSubmiting, setOnSubmiting] = React.useState<boolean>(false);
	const [open, setOpen] = React.useState(false);
	
	const [operacao, setOperacao] = React.useState<EFORM>(props.operacao);
	const [conteudoFormUpdate, setConteudoFormUpdate] = React.useState<IFormStateEntidades>(props.entidade);
	const [generosList, setGenerosList] = React.useState<IEntidadesData[]>([]);
	const [selectedGeneros, setSelectedGeneros] = React.useState<number[]>([]);
	const [produtorasList, setProdutorasList] = React.useState<IProdutoras[]>([]);
	const [selectedProdutoras, setSelectedProdutoras] = React.useState<number[]>([]);
	const [expandedAccordion, setExpandedAccordion] = React.useState<string[]>([]);
	
	const [listOptionsTipoSeries, setListOptionsTipoSeries] = React.useState<IOptions[]|[]>([]);
	const [listOptionsClassEtaria, setListOptionsClassEtaria] = React.useState<IOptions[]|[]>([]);
	
	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);
	
	const [anexoNomeArquivo, setAnexoNomeArquivo] = React.useState<string[]>([]);
	
	const { control, handleSubmit, register, reset, setValue, formState: { errors }} 
		= useForm<IFormStateEntidades>({reValidateMode: "onSubmit", criteriaMode: "all", shouldFocusError: false, defaultValues: conteudoFormUpdate});

	const { fields: serieAnexos, 			append: appendAnexo, 					remove: removeAnexo } = useFieldArray({ control, name: 'serieAnexos' });

	const [tabItem, setTabItem] = React.useState<number>(0);
	const [tabFormData, setTabFormData] = React.useState<DataType>(DataType.SERIE);

	const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => 
	{
		setTabItem(newValue);

		if(newValue == 0)
			setTabFormData(DataType.SERIE);

		if(newValue == 1)
			setTabFormData(DataType.ANEXOS);

	};

	const handleRemoveAnexoItem = (index) => 
	{
		removeAnexo(index);
		setAnexoNomeArquivo((prevAnexos) => {
			const updatedAnexos = [...prevAnexos];
			updatedAnexos.splice(index, 1);
			return updatedAnexos;
		});
	};

	React.useEffect(() =>
	{
		setListOptionsTipoSeries(OptsController.tipoSerie() as IOptions[]);
		setListOptionsClassEtaria(OptsController.classificacaoEtaria() as IOptions[]);
	}, []);

	React.useEffect(() =>
	{
		setUser(appContext?.usuario.user)
		setUserRolerAdmin(appContext.permissao.administrador)
	},[appContext])
    
	React.useEffect(() =>
	{
		reset(conteudoFormUpdate);
	}, [conteudoFormUpdate]);

	const handleSuccess = React.useCallback((msgSucesso: string) => 
	{
		setOnSubmiting(false);
		bananinhaDelegate?.abrir(msgSucesso ? msgSucesso : "Item " + (operacao == EFORM.ADD ? "criado" : "alterado") + " com sucesso.", "success");
	}, [bananinhaDelegate])
	const handleError = React.useCallback((combinedErrors: string) => 
	{
		setOnSubmiting(false);
		bananinhaDelegate?.abrir(combinedErrors, "error");
	}, [bananinhaDelegate])
	const onInvalid = (state: any) => 
	{
		let erroMsg = '<ul>';

        erroMsg += bananinhaListError(state, ETYPEFORM.SERIES);
        
        erroMsg += '<ul>';
        
        handleError(erroMsg)
	}

	async function onSubmit(data: IFormStateEntidades)
	{
		setOnSubmiting(true);
	
		if (operacao == EFORM.ADD) {
			data.idQuemCadastrou = user.uid;
		} else {
			data.idQuemAlterou = user.uid;
		}
		
		data.generos = selectedGeneros;
		data.produtoras = selectedProdutoras;

		if(tabFormData == DataType.ANEXOS)
		{
			let anexosFiltrados = [];

			if(serieAnexos && serieAnexos.length > 0)
				anexosFiltrados = serieAnexos.filter( (anexo:any) => anexo.nome !== "invalid")

			data.serieAnexos = anexosFiltrados;
		}
		
		if(tabFormData == DataType.PROGRAMA)
		{
			delete data.serieAnexos;
		}
	
		try 
		{
			if (!userRoleAdmin) {
				throw new Error('Usuário não tem permissão para enviar o formulário.');
			}
		
			var res: IRetornoAjaxEntidades;
			const formData = new FormData();
			
			if (operacao == EFORM.ADD)
			{
				prepararSerieFormData(data, formData);

				res = await EntController.seriesCreate(formData);

				if (res && (res.status == 200 || res.status == 201))
				{
					handleSuccess(res.message);

					setConteudoFormUpdate(res.Data as unknown as IFormStateEntidades);
					setOperacao(EFORM.UPDATE);
					setTabFormData(DataType.ANEXOS);
					setTabItem(1);
				}
				else
					handleError(res.message);			
			}
			else
			{
				let res:any;

				if(tabFormData == DataType.ANEXOS)
				{
					prepararFormDataAnexo(data, formData);
					
					res = await EntController.seriesUpdate(formData, DataType.ANEXOS);

				} else {
					prepararSerieFormData(data, formData);

					res = await EntController.seriesUpdate(formData, DataType.SERIE);
				}

				if (res && (res.status == 200 || res.status == 201))
				{
					handleSuccess(res.message);

					setTimeout(() => {
						props.setOpenDialog(false);
						props.setEntidade(null);
					}, 5000);

					setOpen(false);
				}
				else
					handleError(res.message);
			}
		}
		catch (e)
		{
			handleError(e.message);
		}
		finally
		{
			setOnSubmiting(false);
			props.callBack();
		}
	}

	React.useEffect(() =>
	{
		if(props.openDialog)
			setOpen(true)
	},[props.openDialog])

	const getGeneros = async () =>
	{
		try {
			const res:IRetornoAjaxEntidades = await EntController.generoList();
			if (res.status == 200 && res.Data?.rows?.length > 0)
				setGenerosList(res.Data.rows);
		} catch(e) {
			bananinhaDelegate?.abrir(e, "error");
		}
	}
   
	const getProdutoras = async () =>
	{
		try {
			const res:IRetornoAjaxEntidades = await EntController.produtoraList();
			if (res.status == 200 && res.Data?.rows?.length > 0)
				setProdutorasList(res.Data.rows);
		} catch(e) {
			bananinhaDelegate?.abrir(e, "error");
		}
	}

	React.useEffect(() =>
	{
		var selectedIDs: number[];

		selectedIDs = [];
		getGeneros();
		if (!isUndefined(conteudoFormUpdate.generos)) {
			selectedIDs = conteudoFormUpdate.generos.map((item: any) => item.idGenero);
		}
		setSelectedGeneros(selectedIDs);

		selectedIDs = [];
		getProdutoras();
		if (!isUndefined(conteudoFormUpdate.produtoras)) {
			selectedIDs = conteudoFormUpdate.produtoras.map((item: any) => item.idProdutora);
		}
		setSelectedProdutoras(selectedIDs);
	}, [])

	const handleAccordion = (id: string) =>
	{
		const pos = expandedAccordion.indexOf(id);
		if (pos == -1) {
			setExpandedAccordion(atual => [...atual, id]);
		} else {
			expandedAccordion.splice(pos, 1);
			setExpandedAccordion(atual => [...expandedAccordion]);
		}
	}

	const isView = (userRoleAdmin && props.listViews) || !userRoleAdmin;
	const isMenorLG = useMediaQuery(() => appTema.breakpoints.down('lg'));
	const isMenorSM = useMediaQuery(() => appTema.breakpoints.down('sm'));

	return <>
		<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
		{
			user && conteudoFormUpdate && 
				<AddEditComponent 
					ehDialog={true}
					tituloCaller={(operacao == EFORM.ADD ? "Adicionar" : props.listViews ? "Visualizar" : "Editar") + " Série"}
					onSubmitingCaller={onSubmiting} 
					handleSubmitCaller={handleSubmit(onSubmit, onInvalid)}
					openCaller={open} 
					listViews={props.listViews}
					dataType={tabFormData}
					onCloseCaller={() => {
						setOpen(false);
						props.setOpenDialog(false);
						props.setEntidade(null);
					}} 
				>
					<Grid item xs={12}>
						<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<Tabs value={tabItem} onChange={handleChangeTab} aria-label="basic tabs example">
								<Tab label="Informações da Série" {...a11yProps(0)} icon={<ChecklistIcon />} iconPosition='start' />
								<Tab label="Anexos" {...a11yProps(1)} disabled={operacao == EFORM.ADD ? true : false} icon={<AttachFileIcon />} iconPosition='start' />
							</Tabs>
						</Box>
					</Grid>
					<CustomTabPanel value={tabItem} index={0}>
						{
						//#region CAMPOS SÉRIE				
						}
							<Grid item xs={12}>
								<Controller
									name="titulo"
									control={control}
									//	defaultValue={conteudoFormUpdate.titulo}
									rules={{
										required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:200, message:`${validacao.maxLength} 200`, }
									}}
									render={({ field }) => (
										<TextField
											{...field} 
											label="Título *"
											fullWidth
											size="small"
											inputProps={{
												maxLength:200,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.titulo ? errors.titulo.message : null}
											error={!!errors.titulo}
											aria-invalid={!!errors.titulo}
										/>
									)}
								/>
							</Grid>
							{ 
								operacao === EFORM.UPDATE && !isNull(conteudoFormUpdate.tituloPortugues) ? (
									<Grid item xs={12}>
										<Controller
											name="tituloPortugues"
											control={control}
											//	defaultValue={conteudoFormUpdate.tituloPortugues}
											rules={{
												// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
												maxLength: { value:200, message:`${validacao.maxLength} 200`, }
											}}
											render={({ field }) => (
												<TextField
													{...field} 
													label="Título em português"
													fullWidth
													size="small"
													inputProps={{
														maxLength:200,
														readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
													}}
													helperText={errors.tituloPortugues ? errors.tituloPortugues.message : null}
													error={!!errors.tituloPortugues}
													aria-invalid={!!errors.tituloPortugues}
												/>
											)}
										/>
									</Grid>
								) 
								: null
							}
							<Grid item xs={12} sm={4}>
								{
									listOptionsTipoSeries &&
										<Controller
											name="tipoSerie"
											control={control}
											rules={{
												required: validacao.requerido, 
											}}
											render={({ field }) => (
												<TextField
													{...field}
													SelectProps={{
														readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual															
													}}
													select
													id="tipoSerie"
													label="Tipo de série *"
													fullWidth
													size="small"
													helperText={errors.tipoSerie ? errors.tipoSerie.message : null}
													error={!!errors.tipoSerie}
													aria-invalid={!!errors.tipoSerie}
													value={field.value || undefined}
												>
													<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
													{
														listOptionsTipoSeries.map((option:IOptions,tipoSerieKey) =>
															<MenuItem value={option.value} key={tipoSerieKey}>{option.name}</MenuItem>
														)
													}
												</TextField>
											)}
										/>
								}
							</Grid>
							<Grid item xs={12} sm={4}>
								<Controller
									name="numeroEpisodios"
									control={control}
									rules={{ 
										required: validacao.requerido,
										//minLength: { value:1, message:`${validacao.minLength} 1`, },
										//maxLength: { value:5, message:`${validacao.maxLength} 5`, },
										validate: {
											isWithinRange: (value) => 
											{
												// const numericValue = parseInt(value, 10);
												if (value >= 1 && value <= 9999) {
													return true;
												} else {
													return 'Deve ser >= 1 e <= 9999';
												}
											},
										},
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Número de episódios *" 
											type="number"
											fullWidth
											size="small"
											inputProps={{
												maxLength:5,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.numeroEpisodios ? errors.numeroEpisodios.message : null}
											error={!!errors.numeroEpisodios}
											aria-invalid={!!errors.numeroEpisodios}
			//								value={field.value || ''}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Controller
									name="anoProducao"
									control={control}
									rules={{ 
										required: validacao.requerido,
										//minLength: { value:4, message:`${validacao.minLength} 4`, },
										//maxLength: { value:4, message:`${validacao.maxLength} 4`, },
										validate: {
											isWithinRange: (value) => 
											{
												const numericValue = parseInt(value, 10);
												if (numericValue >= 1900 && numericValue <= 2150) {
													return true;
												} else {
													return 'Deve ser >= 1900 e <= 2150';
												}
											},
										},
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Ano da produção (temporada) *" 
											type="number"
											fullWidth
											size="small"
											inputProps={{
												maxLength:4,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.anoProducao ? errors.anoProducao.message : ''}
											error={!!errors.anoProducao}
											aria-invalid={!!errors.anoProducao}
			//								value={field.value || ''}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								{ generosList.length > 0 &&
									<Controller
										name="generos"
										control={control}
										rules={{ 
											required: validacao.requerido,
										}}
										render={({ field }) => (
											<Autocomplete
												{...field}
												id="generos-autocomplete"
												fullWidth
												size="small"
												autoHighlight
												multiple
												readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
												options={generosList}
												getOptionLabel={(option) => option.nome}
												value={selectedGeneros.map((selectedId) => generosList.find((genero:any) => genero.idGenero === selectedId))}
												onChange={(_, selectedOptions) => {
													const selectedValues = selectedOptions.map((option) => option.idGenero);
													setSelectedGeneros(selectedValues);
													field.onChange(selectedValues);
												}}
												renderOption={(props, option, { inputValue }) => {
													const matches = match(option.nome, inputValue, { insideWords: true });
													const parts = parse(option.nome, matches);								
													return (
														<li {...props}>
															<div>
																{parts.map((part, index) => ( <span key={index} style={{ fontWeight: part.highlight ? 500 : "inherit" }}>{part.text}</span> ))}
															</div>
														</li>
													);
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Gêneros *"
														variant="outlined"
														helperText={errors.generos ? errors.generos.message : ''}
														error={!!errors.generos}
														aria-invalid={!!errors.generos}
													/>
												)}
											/>
										)}
									/>
								}
							</Grid>
							<Grid item xs={12}>
								{ produtorasList.length > 0 &&
									<Controller
										name="produtoras"
										control={control}
										rules={{ 
											// required: validacao.requerido,
										}}
										render={({ field }) => (
											<Autocomplete
												{...field}
												id="produtoras-autocomplete"
												fullWidth
												size="small"
												autoHighlight
												readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
												multiple
												options={produtorasList}
												getOptionLabel={(option) => option.nome}
												value={selectedProdutoras.map((selectedId) => produtorasList.find((produtora) => produtora.idProdutora === selectedId))}
												onChange={(_, selectedOptions) => {
													const selectedValues = selectedOptions.map((option) => option.idProdutora);
													setSelectedProdutoras(selectedValues);
													field.onChange(selectedValues);
												}}
												renderOption={(props, option, { inputValue }) => {
													const matches = match(option.nome, inputValue, { insideWords: true });
													const parts = parse(option.nome, matches);								
													return (
														<li {...props}>
															<div>
																{parts.map((part, index) => ( <span key={index} style={{ fontWeight: part.highlight ? 500 : "inherit" }}>{part.text}</span> ))}
															</div>
														</li>
													);
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Produtoras"
														variant="outlined"
														helperText={errors.produtoras ? errors.produtoras.message : ''}
														error={!!errors.produtoras}
														aria-invalid={!!errors.produtoras}
													/>
												)}
											/>
										)}
									/>
								}
							</Grid>
							<Grid item xs={12} sm={3}>
								<Controller
									name="numeroCpb"
									control={control}
									rules={{ 
										// required: validacao.requerido,
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:20, message:`${validacao.maxLength} 20` },
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="CPB"
											fullWidth
											size="small"
											inputProps={{
												maxLength:20,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.numeroCpb ? errors.numeroCpb.message : null}
											error={!!errors.numeroCpb}
											aria-invalid={!!errors.numeroCpb}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<FormControl fullWidth size="small">
									<Controller
										name="possuiNumeroCrt"
										control={control}
										render={({ field }) => (
											<StyledStack direction="row" spacing={1}>
												<InputLabel shrink>Possui CRT?</InputLabel>
												<Typography className='semDestaque'>Não</Typography>
												<Switch
													{...field}
													disabled={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false}
													size='small'
													defaultChecked={conteudoFormUpdate.possuiNumeroCrt ? conteudoFormUpdate.possuiNumeroCrt : false}
												/>
												<Typography>Sim</Typography>
											</StyledStack>
										)}
									/>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={3}>
								<Controller
									name="numeroCrt"
									control={control}
									rules={{ 
										// required: validacao.requerido,
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:20, message:`${validacao.maxLength} 20` },
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="CRT"
											fullWidth
											size="small"
											inputProps={{
												maxLength:20,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.numeroCrt ? errors.numeroCrt.message : null}
											error={!!errors.numeroCrt}
											aria-invalid={!!errors.numeroCrt}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
									<Controller
										name="prazoCrtCpb"
										control={control}
										rules={{ 
											validate: value => isValidDate(value) || 'Deve ser >= 1900 e <= 2150'
										}}
										render={({ field }) => (
											<DatePicker
												{...field}
													label="Prazo CRT/CPB"
													value={conteudoFormUpdate.prazoCrtCpb ? dayjs.utc(conteudoFormUpdate.prazoCrtCpb) as unknown as string : null}
													slotProps={{
														textField: {
														size: 'small',
														fullWidth: true,
														helperText: errors.prazoCrtCpb ? errors.prazoCrtCpb.message : null,
														error: !!errors.prazoCrtCpb,
														},
													}}
													maxDate={dayjs.utc('2151-01-01') as unknown as string}
													readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
													format="DD-MM-YYYY"
													onChange={(value) => {
														const formattedDate = value ? dayjs(value).format('YYYY-MM-DD') : null;
														setValue('prazoCrtCpb', formattedDate);
													}}
													aria-invalid={!!errors.prazoCrtCpb}
											/>								
										)}
									/>
								</LocalizationProvider>
							</Grid>
							<Grid item xs={12} sm={6}>
								<LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
									<Controller
										name="dataAlerta"
										control={control}
										rules={{ 
											validate: value => isValidDate(value) || 'Deve ser >= 1900 e <= 2150'
										}}
										render={({ field }) => (
											<DatePicker
												{...field}
													label="Data alerta"
													value={conteudoFormUpdate.dataAlerta ? dayjs.utc(conteudoFormUpdate.dataAlerta) as unknown as string : null}
													slotProps={{
														textField: {
														size: 'small',
														fullWidth: true,
														helperText: errors.dataAlerta ? errors.dataAlerta.message : null,
														error: !!errors.dataAlerta,
														},
													}}
													maxDate={dayjs.utc('2151-01-01') as unknown as string}
													readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
													format="DD-MM-YYYY"
													onChange={(value) => {
														const formattedDate = value ? dayjs(value).format('YYYY-MM-DD') : null;
														setValue('dataAlerta', formattedDate);
													}}
													aria-invalid={!!errors.dataAlerta}
											/>
										)}
									/>
								</LocalizationProvider>
							</Grid>
							<Grid item xs={12} sm={6}>
								{
									listOptionsClassEtaria &&
										<Controller
											name="classificacaoEtaria"
											control={control}
											rules={{
												// required: validacao.requerido, 
											}}
											render={({ field }) => (
												<TextField
													{...field}
													select
													SelectProps={{
														readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual															
													}}
													label="Classificação etária"
													fullWidth
													size="small"
													defaultValue={field.value ? field.value : ""}
													helperText={errors.classificacaoEtaria ? errors.classificacaoEtaria.message : null}
													error={!!errors.classificacaoEtaria}
													aria-invalid={!!errors.classificacaoEtaria}
												>
													<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em >Selecione uma opção</em></MenuItem>
													{
														listOptionsClassEtaria.map((option:IOptions,tipoSerieKey) =>
															<MenuItem value={option.value} key={tipoSerieKey}>{option.name}</MenuItem>
														)
													}
												</TextField>
											)}
										/>
								}
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="titularidade"
									control={control}
									rules={{
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField
											{...field} 
											label="Titularidade"
											inputProps={{
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
											}}
											multiline
											minRows={2}
											maxRows={5}
											fullWidth
											size="small"
											helperText={errors.titularidade ? errors.titularidade.message : null}
											error={!!errors.titularidade}
											aria-invalid={!!errors.titularidade}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="sinopseSerie"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Sinopse"
											inputProps={{
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
											}}
											multiline
											minRows={2}
											maxRows={5}
											fullWidth
											size="small"
											helperText={errors.sinopseSerie ? errors.sinopseSerie.message : null}
											error={!!errors.sinopseSerie} 
											aria-invalid={!!errors.sinopseSerie}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="patrocinador"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label={'Patrocinadores'}
											multiline
											inputProps={{
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
											}}
											minRows={2}
											maxRows={5}
											fullWidth
											size="small"
											helperText={errors.patrocinador ? errors.patrocinador.message : null}
											error={!!errors.patrocinador} 
											aria-invalid={!!errors.patrocinador} 
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="parceiroInstitucional"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label={'Parceiro institucional'}
											multiline
											inputProps={{
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
											}}
											minRows={2}
											maxRows={5}
											fullWidth
											size="small"
											helperText={errors.parceiroInstitucional ? errors.parceiroInstitucional.message : null}
											error={!!errors.parceiroInstitucional} 
											aria-invalid={!!errors.parceiroInstitucional} 
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="areaInteresse"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label={'Áreas de interesse'}
											multiline
											inputProps={{
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
											}}
											minRows={2}
											maxRows={5}
											fullWidth
											size="small"
											helperText={errors.areaInteresse ? errors.areaInteresse.message : null}
											error={!!errors.areaInteresse} 
											aria-invalid={!!errors.areaInteresse} 
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="apresentador"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Apresentador" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:100,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.apresentador ? errors.apresentador.message : null}
											error={!!errors.apresentador}
											aria-invalid={!!errors.apresentador}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="direcao"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Direção" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:100,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.direcao ? errors.direcao.message : null}
											error={!!errors.direcao}
											aria-invalid={!!errors.direcao}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="elenco"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField
											{...field}
											label="Elenco" 
											multiline
											inputProps={{
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
											}}
											minRows={2}
											maxRows={5}
											fullWidth
											size="small"
											helperText={errors.elenco ? errors.elenco.message : null}
											error={!!errors.elenco}
											aria-invalid={!!errors.elenco}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="roteiro"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Roteiro" 
											multiline
											inputProps={{
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
											}}
											minRows={2}
											maxRows={5}
											fullWidth
											size="small"
											helperText={errors.roteiro ? errors.roteiro.message : null}
											error={!!errors.roteiro}
											aria-invalid={!!errors.roteiro}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="producao"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Produção" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:100,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.producao ? errors.producao.message : null}
											error={!!errors.producao}
											aria-invalid={!!errors.producao}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="fotografia"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Fotografia" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:100,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.fotografia ? errors.fotografia.message : null}
											error={!!errors.fotografia}
											aria-invalid={!!errors.fotografia}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="edicao"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Edição" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:100,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.edicao ? errors.edicao.message : null}
											error={!!errors.edicao}
											aria-invalid={!!errors.edicao}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="trilhaOriginal"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Trilha original (autor)" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:100,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.trilhaOriginal ? errors.trilhaOriginal.message : null}
											error={!!errors.trilhaOriginal}
											aria-invalid={!!errors.trilhaOriginal}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="parceria"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Parceria" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:100,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.parceria ? errors.parceria.message : null}
											error={!!errors.parceria}
											aria-invalid={!!errors.parceria}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="consultoria"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Consultoria" 
											multiline
											inputProps={{
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
											}}
											minRows={2}
											maxRows={5}
											fullWidth
											size="small"
											helperText={errors.consultoria ? errors.consultoria.message : null}
											error={!!errors.consultoria}
											aria-invalid={!!errors.consultoria}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="narrador"
									control={control}
									rules={{ 
										// required: validacao.requerido, 
										// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
										maxLength: { value:100, message:`${validacao.maxLength} 100`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="Narrador" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:100,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.narrador ? errors.narrador.message : null}
											error={!!errors.narrador}
											aria-invalid={!!errors.narrador}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Controller
									name="sol"
									control={control}
									rules={{ 
										// required: validacao.requerido,
										// minLength: { value:1, message:`${validacao.minLength} 1`, },
										maxLength: { value:20, message:`${validacao.maxLength} 20`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="SOL" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:20,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.sol ? errors.sol.message : null}
											error={!!errors.sol}
											aria-invalid={!!errors.sol}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Controller
									name="pjur"
									control={control}
									rules={{ 
										// required: validacao.requerido,
										// minLength: { value:1, message:`${validacao.minLength} 1`, },
										maxLength: { value:20, message:`${validacao.maxLength} 20`, }
									}}
									render={({ field }) => (
										<TextField 
											{...field}
											label="PJUR" 
											fullWidth
											size="small"
											inputProps={{
												maxLength:20,
												readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual									
											}}
											helperText={errors.pjur ? errors.pjur.message : null}
											error={!!errors.pjur}
											aria-invalid={!!errors.pjur}
										/>
									)}
								/>
							</Grid>
						{
						//endregion
						}
						{
						//#region RELACIONADOS				
						}
							{ operacao == EFORM.UPDATE && conteudoFormUpdate.programas && conteudoFormUpdate.programas.length > 0 &&
								<Grid item xs={12}>
									<StyledAccordion expanded={expandedAccordion.indexOf('relacionados') >= 0} onChange={() => { handleAccordion('relacionados') }}>
										<StyledAccordionSummary>
											<Typography>Programas relacionados</Typography>
										</StyledAccordionSummary>
										<StyledAccordionDetails>
											<Grid container>
												{ conteudoFormUpdate.programas.map((item:ProgramaModel, keyProgramas:any) =>
													<React.Fragment key={keyProgramas}>
														<Grid item xs={12} lg={6} key={keyProgramas}>
															• <Button size="small" variant="text" sx={{justifyContent: 'flex-start'}} endIcon={<OpenInNewOutlinedIcon/>} href={AppConfig.PATHS.Dashboard.programas.lista + '/' + item.idPrograma + (isView ? '?view=true' : '')} target='_blank' >{item.titulo}</Button>
														</Grid>
													</React.Fragment>
												)}
											</Grid>
										</StyledAccordionDetails>
									</StyledAccordion>
								</Grid>
							}
						{
						//endregion
						}
					</CustomTabPanel>
					<CustomTabPanel value={tabItem} index={1}>
						{
						//#region ANEXOS				
						}
						{
							<Grid item xs={12}>	
								<StyledAccordion expanded={expandedAccordion.indexOf('anexos') >= 0 ? true : false } onChange={() => {handleAccordion('anexos')}}>
									<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
										<Typography>Anexos</Typography>
									</StyledAccordionSummary>
									<StyledAccordionDetails>
										<Grid container spacing={2}>
											<Grid item xs={12}>
											{/*console.log(serieAnexos)*/}
												<Grid container>
													{
														serieAnexos
														.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.ANEXO)
														.map((fieldAnexos) => 
														{
															
														const originalIndex = serieAnexos.findIndex(item => item.id === fieldAnexos.id);
														
															return (
															<React.Fragment key={fieldAnexos.id}>
																{
																	(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.ANEXO) &&
																		<Grid item xs={12}>
																			<Paper
																				variant={isMenorSM ? 'outlined' : 'elevation'}
																				elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																				sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																			>
																				<Grid container spacing={1} alignItems={"center"}>
																					<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																							
																						<Controller
																							name={`serieAnexos.${originalIndex}.nome`}
																							control={control}
																							render={({ field }) => (
																								<Button
																									id={`serieAnexos.${originalIndex}.nome`}
																									size="medium"
																									variant="text"
																									data-type="buttonLink"
																									href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																									endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																									target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																									color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																									className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																									sx={{overflowWrap:"anywhere"}}
																								>
																									{ field.value }	{/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																								</Button>
																							)}
																						/> 
																					</Grid>

																					<Grid item xs={12} sm={2} lg={1}>
																						{
																							userRoleAdmin && !props.listViews ? 
																							// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																									<Button
																										id={'remove_inptAnexo-' + originalIndex}
																										type="button"
																										color="error"
																										fullWidth
																										size="medium"
																										variant="outlined"
																										onClick={() => handleRemoveAnexoItem(originalIndex)}
																										title="Excluir item"
																										sx={botaoIcone}>
																										<DeleteIcon/>
																									</Button> 
																							: ''
																						}
																					</Grid>
																				</Grid>
																			</Paper>
																		</Grid>
																}
															</React.Fragment>
														);
													})}
												</Grid>

												{
													// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
													userRoleAdmin && !props.listViews ?
														<>
															<Button
																component="label"
																role={undefined}
																variant="outlined"
																color="primary"
																tabIndex={-1}
																startIcon={<CloudUploadIcon />}
																id="uploadMultipleAnexos"
																title="Adicionar anexos"
																>
																Adicionar anexos
																<VisuallyHiddenInput
																	type="file"
																	multiple
																	onChange={(e) => 
																	{
																		const files = Array.from((e.target as HTMLInputElement).files!);
																
																		if (files)
																		{
																			// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																			files.forEach((file) => 
																			{
																				const simulatedFileList = createSimulatedFileList(file);
																	
																				appendAnexo([
																					{
																						nome: file.name,
																						tipo: TipoAnexo.ANEXO,
																						arquivo: simulatedFileList, // Passa o FileList simulado
																					} as unknown as IPropsAnexo,
																				]);
																			});
																
																		// Adiciona um item "fake" no final
																			appendAnexo([
																				{
																					nome: "invalid",
																					tipo: TipoAnexo.ANEXO,
																					arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																				} as unknown as IPropsAnexo,
																			]);
																		}
																	}}
																/>
															</Button>

															{/* <Button
																startIcon={ <PlaylistAddIcon /> }
																variant="outlined"
																color="primary"
																title="Adicionar anexo"
																onClick={() => {handleAppendAnexoItem()}}
															>
																Adicionar anexo
															</Button> */}
														</>
													: ''
												}
											</Grid>
										</Grid>
									</StyledAccordionDetails>
								</StyledAccordion>
							</Grid>
						}
						{
						//#endregion
						}
						{
						//#region AUTORIZACAO				
						}
						{
							!props.listViews || props.listViews?
								<Grid item xs={12}>	
									<StyledAccordion expanded={expandedAccordion.indexOf('autorizacoes') >= 0 ? true : false } onChange={() => {handleAccordion('autorizacoes')}}>
										<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
											<Typography>Autorizações</Typography>
										</StyledAccordionSummary>
										<StyledAccordionDetails>
											<Grid container spacing={2}>
												<Grid item xs={12}>
												{/*console.log(serieAnexos)*/}
													<Grid container>
														{
															serieAnexos
															.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.AUTORIZACAO)
															.map((fieldAnexos) => 
															{
																
															const originalIndex = serieAnexos.findIndex(item => item.id === fieldAnexos.id);
															
																return (
																<React.Fragment key={fieldAnexos.id}>
																	{
																		(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.AUTORIZACAO) &&
																			<Grid item xs={12}>
																				<Paper
																					variant={isMenorSM ? 'outlined' : 'elevation'}
																					elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																					sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																				>
																					<Grid container spacing={1} alignItems={"center"}>
																						<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																								
																							<Controller
																								name={`serieAnexos.${originalIndex}.nome`}
																								control={control}
																								render={({ field }) => (
																									<Button
																										id={`serieAnexos.${originalIndex}.nome`}
																										size="medium"
																										variant="text"
																										data-type="buttonLink"
																										href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																										endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																										target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																										color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																										className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																										sx={{overflowWrap:"anywhere"}}
																									>
																										{ field.value } {/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																									</Button>
																								)}
																							/> 
																						</Grid>

																						<Grid item xs={12} sm={2} lg={1}>
																							{
																								userRoleAdmin && !props.listViews ? 
																								// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																										<Button
																											id={'remove_inptAnexo-' + originalIndex}
																											type="button"
																											color="error"
																											fullWidth
																											size="medium"
																											variant="outlined"
																											onClick={() => handleRemoveAnexoItem(originalIndex)}
																											title="Excluir item"
																											sx={botaoIcone}>
																											<DeleteIcon/>
																										</Button> 
																								: ''
																							}
																						</Grid>
																					</Grid>
																				</Paper>
																			</Grid>
																	}
																</React.Fragment>
															);
														})}
													</Grid>

													{
														// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
														userRoleAdmin && !props.listViews ?
															<>
																<Button
																	component="label"
																	role={undefined}
																	variant="outlined"
																	color="primary"
																	tabIndex={-1}
																	startIcon={<CloudUploadIcon />}
																	id="uploadMultipleAutorizacoes"
																	title="Adicionar autorizações"
																	>
																	Adicionar autorizações
																	<VisuallyHiddenInput
																		type="file"
																		multiple
																		onChange={(e) => 
																		{
																			const files = Array.from((e.target as HTMLInputElement).files!);
																	
																			if (files)
																			{
																				// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																				files.forEach((file) => 
																				{
																					const simulatedFileList = createSimulatedFileList(file);
																		
																					appendAnexo([
																						{
																							nome: file.name,
																							tipo: TipoAnexo.AUTORIZACAO,
																							arquivo: simulatedFileList, // Passa o FileList simulado
																						} as unknown as IPropsAnexo,
																					]);
																				});
																	
																			// Adiciona um item "fake" no final
																				appendAnexo([
																					{
																						nome: "invalid",
																						tipo: TipoAnexo.AUTORIZACAO,
																						arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																					} as unknown as IPropsAnexo,
																				]);
																			}
																		}}
																	/>
																</Button>

																{/* <Button
																	startIcon={ <PlaylistAddIcon /> }
																	variant="outlined"
																	color="primary"
																	title="Adicionar anexo"
																	onClick={() => {handleAppendAnexoItem()}}
																>
																	Adicionar anexo
																</Button> */}
															</>
														: ''
													}
												</Grid>
											</Grid>
										</StyledAccordionDetails>
									</StyledAccordion>
								</Grid> : ''
						}
						{
						//#endregion
						}
						{
						//#region PLANILHAS MUSICAIS				
						}
						{
							!props.listViews || props.listViews ?
								<Grid item xs={12}>	
									<StyledAccordion expanded={expandedAccordion.indexOf('planilhasMusicais') >= 0 ? true : false } onChange={() => {handleAccordion('planilhasMusicais')}}>
										<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
											<Typography>Planilhas Musicais</Typography>
										</StyledAccordionSummary>
										<StyledAccordionDetails>
											<Grid container spacing={2}>
												<Grid item xs={12}>
												{/*console.log(serieAnexos)*/}
													<Grid container>
														{
															serieAnexos
															.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.PLANILHA_MUSICAL)
															.map((fieldAnexos) => 
															{
																
															const originalIndex = serieAnexos.findIndex(item => item.id === fieldAnexos.id);
															
																return (
																<React.Fragment key={fieldAnexos.id}>
																	{
																		(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.PLANILHA_MUSICAL) &&
																			<Grid item xs={12}>
																				<Paper
																					variant={isMenorSM ? 'outlined' : 'elevation'}
																					elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																					sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																				>
																					<Grid container spacing={1} alignItems={"center"}>
																						<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																								
																							<Controller
																								name={`serieAnexos.${originalIndex}.nome`}
																								control={control}
																								render={({ field }) => (
																									<Button
																										id={`serieAnexos.${originalIndex}.nome`}
																										size="medium"
																										variant="text"
																										data-type="buttonLink"
																										href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																										endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																										target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																										color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																										className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																										sx={{overflowWrap:"anywhere"}}
																									>
																										{ field.value } {/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																									</Button>
																								)}
																							/> 
																						</Grid>

																						<Grid item xs={12} sm={2} lg={1}>
																							{
																								userRoleAdmin && !props.listViews ? 
																								// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																										<Button
																											id={'remove_inptAnexo-' + originalIndex}
																											type="button"
																											color="error"
																											fullWidth
																											size="medium"
																											variant="outlined"
																											onClick={() => handleRemoveAnexoItem(originalIndex)}
																											title="Excluir item"
																											sx={botaoIcone}>
																											<DeleteIcon/>
																										</Button> 
																								: ''
																							}
																						</Grid>
																					</Grid>
																				</Paper>
																			</Grid>
																	}
																</React.Fragment>
															);
														})}
													</Grid>

													{
														// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
														userRoleAdmin && !props.listViews ?
															<>
																<Button
																	component="label"
																	role={undefined}
																	variant="outlined"
																	color="primary"
																	tabIndex={-1}
																	startIcon={<CloudUploadIcon />}
																	id="uploadMultipleplanilhasMusicais"
																	title="Adicionar planilhas musicais"
																	>
																	Adicionar planilhas musicais
																	<VisuallyHiddenInput
																		type="file"
																		multiple
																		onChange={(e) => 
																		{
																			const files = Array.from((e.target as HTMLInputElement).files!);
																	
																			if (files)
																			{
																				// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																				files.forEach((file) => 
																				{
																					const simulatedFileList = createSimulatedFileList(file);
																		
																					appendAnexo([
																						{
																							nome: file.name,
																							tipo: TipoAnexo.PLANILHA_MUSICAL,
																							arquivo: simulatedFileList, // Passa o FileList simulado
																						} as unknown as IPropsAnexo,
																					]);
																				});
																	
																			// Adiciona um item "fake" no final
																				appendAnexo([
																					{
																						nome: "invalid",
																						tipo: TipoAnexo.PLANILHA_MUSICAL,
																						arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																					} as unknown as IPropsAnexo,
																				]);
																			}
																		}}
																	/>
																</Button>

																{/* <Button
																	startIcon={ <PlaylistAddIcon /> }
																	variant="outlined"
																	color="primary"
																	title="Adicionar anexo"
																	onClick={() => {handleAppendAnexoItem()}}
																>
																	Adicionar anexo
																</Button> */}
															</>
														: ''
													}
												</Grid>
											</Grid>
										</StyledAccordionDetails>
									</StyledAccordion>
								</Grid> : ''
						}
						{
						//#endregion
						}
						{
						//#region MATERIAIS DE DIVULGAÇÃO
						}
						{
							!props.listViews || props.listViews ?
								<Grid item xs={12}>	
									<StyledAccordion expanded={expandedAccordion.indexOf('materiaisDivulgacao') >= 0 ? true : false } onChange={() => {handleAccordion('materiaisDivulgacao')}}>
										<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
											<Typography>Materiais de Divulgação</Typography>
										</StyledAccordionSummary>
										<StyledAccordionDetails>
											<Grid container spacing={2}>
												<Grid item xs={12}>
												{/*console.log(serieAnexos)*/}
													<Grid container>
														{
															serieAnexos
															.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.MATERIAL_DIVULGACAO)
															.map((fieldAnexos) => 
															{
																
															const originalIndex = serieAnexos.findIndex(item => item.id === fieldAnexos.id);
															
																return (
																<React.Fragment key={fieldAnexos.id}>
																	{
																		(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.MATERIAL_DIVULGACAO) &&
																			<Grid item xs={12}>
																				<Paper
																					variant={isMenorSM ? 'outlined' : 'elevation'}
																					elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																					sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																				>
																					<Grid container spacing={1} alignItems={"center"}>
																						<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																								
																							<Controller
																								name={`serieAnexos.${originalIndex}.nome`}
																								control={control}
																								render={({ field }) => (
																									<Button
																										id={`serieAnexos.${originalIndex}.nome`}
																										size="medium"
																										variant="text"
																										data-type="buttonLink"
																										href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																										endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																										target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																										color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																										className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																										sx={{overflowWrap:"anywhere"}}
																									>
																										{ field.value } {/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																									</Button>
																								)}
																							/> 
																						</Grid>

																						<Grid item xs={12} sm={2} lg={1}>
																							{
																								userRoleAdmin && !props.listViews ? 
																								// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																										<Button
																											id={'remove_inptAnexo-' + originalIndex}
																											type="button"
																											color="error"
																											fullWidth
																											size="medium"
																											variant="outlined"
																											onClick={() => handleRemoveAnexoItem(originalIndex)}
																											title="Excluir item"
																											sx={botaoIcone}>
																											<DeleteIcon/>
																										</Button> 
																								: ''
																							}
																						</Grid>
																					</Grid>
																				</Paper>
																			</Grid>
																	}
																</React.Fragment>
															);
														})}
													</Grid>

													{
														// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
														userRoleAdmin && !props.listViews ?
															<>
																<Button
																	component="label"
																	role={undefined}
																	variant="outlined"
																	color="primary"
																	tabIndex={-1}
																	startIcon={<CloudUploadIcon />}
																	id="uploadMultiplemateriaisDivulgacao"
																	title="Adicionar materiais de divulgação"
																	>
																	Adicionar materiais de divulgação
																	<VisuallyHiddenInput
																		type="file"
																		multiple
																		onChange={(e) => 
																		{
																			const files = Array.from((e.target as HTMLInputElement).files!);
																	
																			if (files)
																			{
																				// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																				files.forEach((file) => 
																				{
																					const simulatedFileList = createSimulatedFileList(file);
																		
																					appendAnexo([
																						{
																							nome: file.name,
																							tipo: TipoAnexo.MATERIAL_DIVULGACAO,
																							arquivo: simulatedFileList, // Passa o FileList simulado
																						} as unknown as IPropsAnexo,
																					]);
																				});
																	
																			// Adiciona um item "fake" no final
																				appendAnexo([
																					{
																						nome: "invalid",
																						tipo: TipoAnexo.MATERIAL_DIVULGACAO,
																						arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																					} as unknown as IPropsAnexo,
																				]);
																			}
																		}}
																	/>
																</Button>

																{/* <Button
																	startIcon={ <PlaylistAddIcon /> }
																	variant="outlined"
																	color="primary"
																	title="Adicionar anexo"
																	onClick={() => {handleAppendAnexoItem()}}
																>
																	Adicionar anexo
																</Button> */}
															</>
														: ''
													}
												</Grid>
											</Grid>
										</StyledAccordionDetails>
									</StyledAccordion>
								</Grid> : ''
						}
						{
						//#endregion
						}
						{
						//#region RECURSOS DE ACESSIBILIDADE
						}
						{
							!props.listViews || props.listViews ?
								<Grid item xs={12}>	
									<StyledAccordion expanded={expandedAccordion.indexOf('recursosAcessibilidade') >= 0 ? true : false } onChange={() => {handleAccordion('recursosAcessibilidade')}}>
										<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
											<Typography>Recursos de Acessibilidade</Typography>
										</StyledAccordionSummary>
										<StyledAccordionDetails>
											<Grid container spacing={2}>
												<Grid item xs={12}>
												{/*console.log(serieAnexos)*/}
													<Grid container>
														{
															serieAnexos
															.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.RECURSO_ACESSIBILIDADE)
															.map((fieldAnexos) => 
															{
																
															const originalIndex = serieAnexos.findIndex(item => item.id === fieldAnexos.id);
															
																return (
																<React.Fragment key={fieldAnexos.id}>
																	{
																		(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.RECURSO_ACESSIBILIDADE) &&
																			<Grid item xs={12}>
																				<Paper
																					variant={isMenorSM ? 'outlined' : 'elevation'}
																					elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																					sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																				>
																					<Grid container spacing={1} alignItems={"center"}>
																						<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																								
																							<Controller
																								name={`serieAnexos.${originalIndex}.nome`}
																								control={control}
																								render={({ field }) => (
																									<Button
																										id={`serieAnexos.${originalIndex}.nome`}
																										size="medium"
																										variant="text"
																										data-type="buttonLink"
																										href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																										endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																										target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																										color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																										className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																										sx={{overflowWrap:"anywhere"}}
																									>
																										{ field.value }	{/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																									</Button>
																								)}
																							/> 
																						</Grid>

																						<Grid item xs={12} sm={2} lg={1}>
																							{
																								userRoleAdmin && !props.listViews ? 
																								// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																										<Button
																											id={'remove_inptAnexo-' + originalIndex}
																											type="button"
																											color="error"
																											fullWidth
																											size="medium"
																											variant="outlined"
																											onClick={() => handleRemoveAnexoItem(originalIndex)}
																											title="Excluir item"
																											sx={botaoIcone}>
																											<DeleteIcon/>
																										</Button> 
																								: ''
																							}
																						</Grid>
																					</Grid>
																				</Paper>
																			</Grid>
																	}
																</React.Fragment>
															);
														})}
													</Grid>

													{
														// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
														userRoleAdmin && !props.listViews ?
															<>
																<Button
																	component="label"
																	role={undefined}
																	variant="outlined"
																	color="primary"
																	tabIndex={-1}
																	startIcon={<CloudUploadIcon />}
																	id="uploadMultiplerecursosAcessibilidade"
																	title="Adicionar recursos de acessibilidade"
																	>
																	Adicionar recursos de acessibilidade
																	<VisuallyHiddenInput
																		type="file"
																		multiple
																		onChange={(e) => 
																		{
																			const files = Array.from((e.target as HTMLInputElement).files!);
																	
																			if (files)
																			{
																				// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																				files.forEach((file) => 
																				{
																					const simulatedFileList = createSimulatedFileList(file);
																		
																					appendAnexo([
																						{
																							nome: file.name,
																							tipo: TipoAnexo.RECURSO_ACESSIBILIDADE,
																							arquivo: simulatedFileList, // Passa o FileList simulado
																						} as unknown as IPropsAnexo,
																					]);
																				});
																	
																			// Adiciona um item "fake" no final
																				appendAnexo([
																					{
																						nome: "invalid",
																						tipo: TipoAnexo.RECURSO_ACESSIBILIDADE,
																						arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																					} as unknown as IPropsAnexo,
																				]);
																			}
																		}}
																	/>
																</Button>

																{/* <Button
																	startIcon={ <PlaylistAddIcon /> }
																	variant="outlined"
																	color="primary"
																	title="Adicionar anexo"
																	onClick={() => {handleAppendAnexoItem()}}
																>
																	Adicionar anexo
																</Button> */}
															</>
														: ''
													}
												</Grid>
											</Grid>
										</StyledAccordionDetails>
									</StyledAccordion>
								</Grid> : ''
						}
						{
						//#endregion
						}
						{
						//#region OUTROS ANEXOS
						}
						{
							!props.listViews || props.listViews ?
								<Grid item xs={12}>	
									<StyledAccordion expanded={expandedAccordion.indexOf('anexosOutros') >= 0 ? true : false } onChange={() => {handleAccordion('anexosOutros')}}>
										<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
											<Typography>Outros Documentos</Typography>
										</StyledAccordionSummary>
										<StyledAccordionDetails>
											<Grid container spacing={2}>
												<Grid item xs={12}>
												{/*console.log(serieAnexos)*/}
													<Grid container>
														{
															serieAnexos
															.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.OUTRO)
															.map((fieldAnexos) => 
															{
																
															const originalIndex = serieAnexos.findIndex(item => item.id === fieldAnexos.id);
															
																return (
																<React.Fragment key={fieldAnexos.id}>
																	{
																		(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.OUTRO) &&
																			<Grid item xs={12}>
																				<Paper
																					variant={isMenorSM ? 'outlined' : 'elevation'}
																					elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																					sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																				>
																					<Grid container spacing={1} alignItems={"center"}>
																						<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																								
																							<Controller
																								name={`serieAnexos.${originalIndex}.nome`}
																								control={control}
																								render={({ field }) => (
																									<Button
																										id={`serieAnexos.${originalIndex}.nome`}
																										size="medium"
																										variant="text"
																										data-type="buttonLink"
																										href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																										endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																										target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																										color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																										className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																										sx={{overflowWrap:"anywhere"}}
																									>
																										{ field.value }	{/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																									</Button>
																								)}
																							/> 
																						</Grid>

																						<Grid item xs={12} sm={2} lg={1}>
																							{
																								userRoleAdmin && !props.listViews ? 
																								// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																										<Button
																											id={'remove_inptAnexo-' + originalIndex}
																											type="button"
																											color="error"
																											fullWidth
																											size="medium"
																											variant="outlined"
																											onClick={() => handleRemoveAnexoItem(originalIndex)}
																											title="Excluir item"
																											sx={botaoIcone}>
																											<DeleteIcon/>
																										</Button> 
																								: ''
																							}
																						</Grid>
																					</Grid>
																				</Paper>
																			</Grid>
																	}
																</React.Fragment>
															);
														})}
													</Grid>

													{
														// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
														userRoleAdmin && !props.listViews ?
															<>
																<Button
																	component="label"
																	role={undefined}
																	variant="outlined"
																	color="primary"
																	tabIndex={-1}
																	startIcon={<CloudUploadIcon />}
																	id="uploadMultipleanexosOutros"
																	title="Adicionar outros documentos"
																	>
																	Adicionar outros documentos
																	<VisuallyHiddenInput
																		type="file"
																		multiple
																		onChange={(e) => 
																		{
																			const files = Array.from((e.target as HTMLInputElement).files!);
																	
																			if (files)
																			{
																				// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																				files.forEach((file) => 
																				{
																					const simulatedFileList = createSimulatedFileList(file);
																		
																					appendAnexo([
																						{
																							nome: file.name,
																							tipo: TipoAnexo.OUTRO,
																							arquivo: simulatedFileList, // Passa o FileList simulado
																						} as unknown as IPropsAnexo,
																					]);
																				});
																	
																			// Adiciona um item "fake" no final
																				appendAnexo([
																					{
																						nome: "invalid",
																						tipo: TipoAnexo.OUTRO,
																						arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																					} as unknown as IPropsAnexo,
																				]);
																			}
																		}}
																	/>
																</Button>

																{/* <Button
																	startIcon={ <PlaylistAddIcon /> }
																	variant="outlined"
																	color="primary"
																	title="Adicionar anexo"
																	onClick={() => {handleAppendAnexoItem()}}
																>
																	Adicionar anexo
																</Button> */}
															</>
														: ''
													}
												</Grid>
											</Grid>
										</StyledAccordionDetails>
									</StyledAccordion>
								</Grid> : ''
						}
						{
						//#endregion
						}
					</CustomTabPanel>
			</AddEditComponent>
		}
	</>
}
export default FormDialog;

interface TabPanelProps
{
	children?: React.ReactNode;
	index: number;
	value: number;
}

function CustomTabPanel(props: TabPanelProps)
{
	const { children, value, index } = props;
	
	return value === index ? <>{children}</> : null;
}

const gridAnexos = {
	'& .hide': {
		position: 'absolute',
		width: 0,
		height: 0,
		overflow: 'hidden',
		opacity: 0,
	},
}

const botaoIcone = {
	minWidth: 'inherit'
}